var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_txt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_txt",
    transform: "translate(-1431 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3697",
    "data-name": "Rectangle 3697",
    width: 24,
    height: 24,
    transform: "translate(1431 13)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "txt",
    d: "M3371.8,7162H3359v-16h8.229v4.7h4.571V7162Zm-7.188-6.747h-.751l1.136,1.86-1.161,1.889h.757l.808-1.374h0l.8,1.374h.76l-1.159-1.889,1.134-1.86h-.753l-.787,1.355Zm3.73.524V7159h.647v-3.225h1.17v-.524h-2.977v.524Zm-6.539,0V7159h.647v-3.225h1.168v-.524h-2.975v.524Zm9.863-6.012h-3.521v-3.625l3.52,3.624Z",
    transform: "translate(-1922.4 -7129.002)",
    fill: "#5f6a7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTxt);
export default __webpack_public_path__ + "static/media/ic_txt.d99142e57c73f7219162559d39fb7c0d.svg";
export { ForwardRef as ReactComponent };